import { useMemo } from 'react'

import { Premise } from '@/api/models/auth/lib/auth.types'

type Props = {
  premises?: Premise[]
  currentPremiseId: string
}

const ContentBlockPremises = ({ premises, currentPremiseId }: Props) => {
  const premiseName = useMemo(() => {
    return premises?.find(premise => premise.id === currentPremiseId)?.name
  }, [premises, currentPremiseId])

  if (premiseName) {
    return (
      <div>
        <p className="mb-4 font-bold text-grey-90 text-16">Помещение</p>
        <div className="font-pro text-16">{premiseName}</div>
      </div>
    )
  }
}

export default ContentBlockPremises
